// Copyright (c) 2023 Deere & Company

import './pip-history-item.scss';
import React, {PropTypes} from 'react';
import IncentivePrograms from '@deere/cps-it.warranty-model-factory/lib/incentive-programs';
import IncentiveProgramsItemHeader from './incentive-programs-item-header';

const IncentiveProgramsItem = props =>

    <section className='pip-history-item'>
        {
            <IncentiveProgramsItemHeader
                incentiveProgram={props.incentiveProgram}
                pin={props.pin}
            />
        }
    </section>;

IncentiveProgramsItem.displayName = 'IncentiveProgramsItem';
IncentiveProgramsItem.propTypes = {
    incentiveProgram: PropTypes.instanceOf(IncentivePrograms).isRequired,
    pin: PropTypes.string.isRequired
};

export default IncentiveProgramsItem;



// WEBPACK FOOTER //
// ./src/product/details/components/incentive-programs-item.js